export { Rating, type RatingProps } from './Rating'
